import type { RunFilters } from '@/api/runs';

/** The runs list's filters as they live in the URL (`/staff/runs?state=failed24h&project=prj_…`). */
export interface RunsSearch {
  /** A run state, or the preset `active` / `failed24h`. */
  state?: string;
  type?: string;
  project?: string;
  analysis?: string;
  /** forint id, forun number (`228`, `run 228`) or external_ref. */
  q?: string;
}

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);

export function validateRunsSearch(s: Record<string, unknown>): RunsSearch {
  return {
    state: str(s.state),
    type: str(s.type),
    project: str(s.project),
    analysis: str(s.analysis),
    // A bare forun number comes back from the URL parsed as a number.
    q: typeof s.q === 'number' ? String(s.q) : str(s.q),
  };
}

/** The URL's filters as the API takes them; `failed24h` is failed and finished within a day of
 * each request, so the polled first page keeps a moving window. */
export function runFilters(search: RunsSearch): RunFilters {
  const { state, ...rest } = search;
  const filters: RunFilters = { ...rest, state };
  if (state === 'failed24h') {
    filters.state = 'failed';
    filters.finishedWithinHours = 24;
  }
  for (const k of Object.keys(filters) as (keyof RunFilters)[]) if (filters[k] === undefined) delete filters[k];
  return filters;
}
